export default class FileService {
    static $inject = ['$base64'];

    constructor($base64) {
        'ngInject';

        this.$base64 = $base64;
    }

    fromDataURI(dataUri) {
        const [match, mimeType, encoding, data] = dataUri.match(/^data:([^;]+);([^,]+),(.+)$/);

        if (!match) return null;

        const bytes = (encoding === 'base64') ? this.$base64.decode(data) : window.decodeURIComponent(data);

        const array = new Uint8Array(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
            array[i] = bytes.charCodeAt(i);
        }

        return new Blob([array], { type: mimeType });
    }

    isDataURI(str) {
        return typeof str === 'string' && !!str.match(/^data:([^;]+);([^,]+),(.+)$/);
    }
}
